import {featureFlags} from './featureFlags.jsx'
import {quoteKinds} from './api.jsx'

export const featureNames = {
  AI_QUOTE: 'lara-redirect',
  TRANSCREATION: 'transcreation',
  ECONOMY: 'economy',
  PREMIUM: 'premium',
  PROFESSIONAL: 'professional',
  CREATIVE: 'creative',
  QUOTE: 'quote',
  INSTANT: 'instant',
  LINK: 'link',
}

class Features {
  async #getSolutionType() {
    await featureFlags.waitUntilLoaded()

    const aiQuoteVariant = await featureFlags.getVariantAsync('lara-redirect')

    if (aiQuoteVariant) {
      return {solutionType: featureNames.AI_QUOTE, variant: aiQuoteVariant}
    }

    if (await featureFlags.isOnAsync(featureNames.TRANSCREATION)) {
      return {solutionType: featureNames.TRANSCREATION}
    }

    return {solutionType: featureNames.ECONOMY}
  }

  async getFirstCardSolution() {
    const {solutionType} = await this.#getSolutionType()
    if (
      [featureNames.TRANSCREATION, featureNames.AI_QUOTE].includes(solutionType)
    ) {
      return featureNames.CREATIVE
    } else {
      return featureNames.PREMIUM
    }
  }

  async getSecondCardSolution() {
    const {solutionType} = await this.#getSolutionType()
    if (
      solutionType === featureNames.TRANSCREATION ||
      solutionType === featureNames.AI_QUOTE
    ) {
      return featureNames.PREMIUM
    }
    return featureNames.PROFESSIONAL
  }

  async getThirdCardSolution() {
    const {solutionType, variant} = await this.#getSolutionType()
    if (solutionType === featureNames.TRANSCREATION) {
      return featureNames.PROFESSIONAL
    }

    if (solutionType === featureNames.AI_QUOTE) {
      if (variant === 'instant') {
        return featureNames.INSTANT
      }
      if (variant === 'lara_tool') {
        return featureNames.LINK
      }

      return featureNames.PROFESSIONAL
    }
    return featureNames.ECONOMY
  }

  async getQuotesToDo() {
    const {solutionType, variant} = await this.#getSolutionType()
    if (solutionType === featureNames.TRANSCREATION) {
      return [
        quoteKinds.transcreation,
        quoteKinds.translationRevision,
        quoteKinds.translation,
      ]
    }

    if (solutionType === featureNames.AI_QUOTE) {
      const quotes = [quoteKinds.transcreation, quoteKinds.translationRevision]
      if (variant === 'instant') {
        quotes.push(quoteKinds.lara)
        quotes.push(quoteKinds.laraHR)
      }
      if (variant === 'pro') {
        quotes.push(quoteKinds.translation)
      }

      return quotes
    }

    return [
      quoteKinds.translationRevision,
      quoteKinds.translation,
      quoteKinds.postediting,
    ]
  }
}

export const features = new Features()
